var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'lang-en': _vm.lang === 'en' },attrs:{"id":"app"}},[_c('keep-alive',[(_vm.ready)?_c('router-view'):_vm._e()],1),_c('FitLoading'),(_vm.ready)?_c('FitDialog'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }